import React from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import './Counts.css'
import CountUp from 'react-countup';
// eslint-disable-next-line
import i18n from "../../i18n";
import { useTranslation } from 'react-i18next';



const Counts = () => {
    const { t, i18n } = useTranslation();
    return (
        <section className="counts section-bg">
            <div className="container">
            <div className="row justify-content-end">

                <div className="col-lg-3 col-md-5 col-6 d-md-flex align-items-md-stretch">
                <div className="count-box">
                    <span><CountUp start={0} end={113} duration={4} /></span>
                    <p>{t('Happy_Clients')}</p>
                </div>
                </div>

                <div className="col-lg-3 col-md-5 col-6 d-md-flex align-items-md-stretch">
                <div className="count-box">
                    <span><CountUp start={0} end={4} duration={4} /></span>
                    <p>{t('Countries')}</p>
                </div>
                </div>

                <div className="col-lg-3 col-md-5 col-6 d-md-flex align-items-md-stretch">
                <div className="count-box">
                <span><CountUp start={0} end={16} duration={4} /></span>
                    <p>{t('Projects')}</p>
                </div>
                </div>

                <div className="col-lg-3 col-md-5 col-6 d-md-flex align-items-md-stretch">
                <div className="count-box">
                <span><CountUp start={0} end={11} duration={4} /></span>
                    <p>{t('Years_of_experience')}</p>
                </div>
                </div>

            </div>
            </div>
        </section>
    )
}

export default Counts
